var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.48 9.765L4.59 11.875H0V12.875H4.62L2.48 14.995L3.17 15.685L6.47 12.385L3.17 9.085L2.48 9.765Z",
    fill: "#7E7E7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.245L6.64 0.315002H1V9.705L2.1 8.635V1.385H6.1L7.42 3.315H14.93V12.405H8L6.88 13.475H16V2.245H8Z",
    fill: "#7E7E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.ba6ce2baac6a57c8cf5e1c4599bd1017.svg";
export { ForwardRef as ReactComponent };